<template>

  <!-- Page Blocks -->
  <div
    class="page-blocks"
    v-if="value && value.length">

    <component
      :value="block"
      :key="block.id"
      v-if="!block.hidden"
      v-for="block in value"
      :is="`${block.type}-block`"
      :id="block.anchor || undefined"/>

  </div>

</template>

<script>

  import ProgramBlock from '@src/components/block/program-block';
  import PersonsBlock from '@src/components/block/persons-block';
  import PageBodyBlock from '@src/components/block/page-body-block';
  import NewsGridBlock from '@src/components/block/news-grid-block';
  import JoinTeamBlock from '@src/components/block/join-team-block';
  import TilesGridBlock from '@src/components/block/tiles-grid-block';
  import ChefAboutBlock from '@src/components/block/chef-about-block';
  import EventsGridBlock from '@src/components/block/events-grid-block';
  import TitledTextBlock from '@src/components/block/titled-text-block';
  import ParticipateBlock from '@src/components/block/participate-block';
  import EventDetailsBlock from '@src/components/block/event-details-block';
  import IconsGalleryBlock from '@src/components/block/icons-gallery-block';
  import IconTextTileBlock from '@src/components/block/icon-text-tile-block';
  import SlidesGalleryBlock from '@src/components/block/slides-gallery-block';
  import ButtonBannersBlock from '@src/components/block/button-banners-block';
  import SearchResultsBlock from '@src/components/block/search-results-block';
  import IconsAccordionBlock from '@src/components/block/icons-accordion-block';
  import AsideImageTileBlock from '@src/components/block/aside-image-tile-block';
  import PastEventsGridBlock from '@src/components/block/past-events-grid-block';
  import FullscreenSlideBlock from '@src/components/block/fullscreen-slide-block';
  import ActiveEventsGridBlock from '@src/components/block/active-events-grid-block';
  import QuizSubjectsGridBlock from '@src/components/block/quiz-subjects-grid-block';
  import TwoColImageCardsBlock from '@src/components/block/two-col-image-cards-block';
  import AnnounceEventsGridBlock from '@src/components/block/announce-events-grid-block';
  import QuizSubjectsSliderBlock from '@src/components/block/quiz-subjects-slider-block';
  import IllustrationGalleryBlock from '@src/components/block/illustration-gallery-block';

  export default {
    name: 'page-blocks',
    props: {
      value: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      ProgramBlock,
      PersonsBlock,
      PageBodyBlock,
      NewsGridBlock,
      JoinTeamBlock,
      ChefAboutBlock,
      TilesGridBlock,
      EventsGridBlock,
      TitledTextBlock,
      ParticipateBlock,
      EventDetailsBlock,
      IconsGalleryBlock,
      IconTextTileBlock,
      SlidesGalleryBlock,
      ButtonBannersBlock,
      SearchResultsBlock,
      PastEventsGridBlock,
      IconsAccordionBlock,
      AsideImageTileBlock,
      FullscreenSlideBlock,
      ActiveEventsGridBlock,
      TwoColImageCardsBlock,
      QuizSubjectsGridBlock,
      AnnounceEventsGridBlock,
      QuizSubjectsSliderBlock,
      IllustrationGalleryBlock,
    },
  };

</script>

<style lang="scss">

  .page-blocks {
    color: inherit;
  }

</style>
